var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "21px",
    viewBox: "0 0 23 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 8,
    transform: "translate(-1345.000000, -526.000000)",
    fill: "#D1D1D1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabla",
    transform: "translate(298.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconos",
    transform: "translate(25.000000, 198.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-download",
    transform: "translate(1022.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,21 C11.3025833,21 11.11475,20.9198182 10.9786667,20.7775909 L6.42658333,16.0048636 C6.22916667,15.7977273 6.17358333,15.4922727 6.28666667,15.2288182 C6.39975,14.9653636 6.66041667,14.7954545 6.94791667,14.7954545 L9.10416667,14.7954545 L9.10416667,10.7386364 C9.10416667,10.0809545 9.64179167,9.54545455 10.3020833,9.54545455 L12.6979167,9.54545455 C13.3582083,9.54545455 13.8958333,10.0809545 13.8958333,10.7386364 L13.8958333,14.7954545 L16.0520833,14.7954545 C16.3395833,14.7954545 16.5992917,14.9663182 16.712375,15.2288182 C16.8254583,15.4913182 16.7708333,15.7967727 16.5724583,16.0048636 L12.020375,20.7775909 C11.88525,20.9198182 11.6974167,21 11.5,21 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8949583,3.7485 C16.637625,1.45854545 14.1727917,0 11.5,0 C8.10270833,0 5.15583333,2.35295455 4.41120833,5.56404545 C1.934875,5.82368182 0,7.89504545 0,10.4045455 C0,12.8835 1.89654167,14.9128636 4.32975,15.2125909 C4.3585,14.9634545 4.42270833,14.7152727 4.52620833,14.4766364 C4.93733333,13.5220909 5.79983333,12.8863636 7.1875,12.8863636 L7.1875,10.7386364 C7.1875,9.02809091 8.58475,7.63636364 10.3020833,7.63636364 L12.6979167,7.63636364 C14.41525,7.63636364 15.8125,9.02809091 15.8125,10.7386364 L15.8125,12.8863636 C17.1905833,12.8863636 18.0597917,13.5125455 18.4737917,14.4766364 C18.5571667,14.6694545 18.6089167,14.8689545 18.6434167,15.0703636 C21.1485,14.4069545 23,12.1561364 23,9.4815 C23,6.55486364 20.789125,4.11218182 17.8949583,3.7485 L17.8949583,3.7485 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDownload);
export default __webpack_public_path__ + "static/media/ico-download.e7352b62d89c6d988702d9ace275ad59.svg";
export { ForwardRef as ReactComponent };